// @ts-nocheck
import React from 'react';
import { connect } from 'react-redux';
import { isMobileBrowser } from '../../base/environment/utils';
import { translate, translateToHTML } from '../../base/i18n/functions';
import Icon from '../../base/icons/components/Icon';
import { IconFacebook, IconInstagram, IconWarning, IconX } from '../../base/icons/svg';
import getUnsafeRoomText from '../../base/util/getUnsafeRoomText.web';
import CalendarList from '../../calendar-sync/components/CalendarList.web';
import RecentList from '../../recent-list/components/RecentList.web';
import SettingsButton from '../../settings/components/web/SettingsButton';
import { SETTINGS_TABS } from '../../settings/constants';
import { _mapStateToProps, AbstractWelcomePage } from './AbstractWelcomePage';
import Tabs from './Tabs';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import i18next from "i18next";
export const MIKUTANO_API_PREF = "https://reservations2.mikutano.co.tz:3004"; //TEST RIDC
// export const MIKUTANO_API_PREF = "http://maombi.ridc.egatest.go.tz:8080"; // TEST DATA-CENTRE -- HTTP
// export const MIKUTANO_API_PREF = "https://maombi.ridc.egatest.go.tz:4444"; // TEST DATA-CENTRE -- HTTPS
// export const MIKUTANO_API_PREF = "http://10.42.0.98:7000";http://172.17.17.99:9004/
// export const MIKUTANO_API_PREF = "http://172.17.17.99:9004";
// export const MIKUTANO_API_PREF = "https://maombi.mikutano.gov.go.tz"; //DATA CENTER LIVE
const axios = require('axios');
/**
 * The pattern used to validate room name.
 *
 * @type {string}
 */
export const ROOM_NAME_VALIDATE_PATTERN_STR = '^[^?&:\u0022\u0027%#]+$';
/**
 * The Web container rendering the welcome page.
 *
 * @augments AbstractWelcomePage
 */
class WelcomePage extends AbstractWelcomePage {
    /**
     * Initializes a new WelcomePage instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            generateRoomNames: interfaceConfig.GENERATE_ROOMNAMES_ON_WELCOME_PAGE
        };
        /**
         * Used To display a warning massage if the title input has no allow character.
         *
         * @private
         * @type {boolean}
         */
        this._titleHasNotAllowCharacter = false;
        /**
         * The HTML Element used as the container for additional content. Used
         * for directly appending the additional content template to the dom.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalContentRef = null;
        this._roomInputRef = null;
        /**
         * The HTML Element used as the container for additional toolbar content. Used
         * for directly appending the additional content template to the dom.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalToolbarContentRef = null;
        this._additionalCardRef = null;
        /**
         * The template to use as the additional card displayed near the main one.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalCardTemplate = document.getElementById('welcome-page-additional-card-template');
        /**
         * The template to use as the main content for the welcome page. If
         * not found then only the welcome page head will display.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalContentTemplate = document.getElementById('welcome-page-additional-content-template');
        /**
         * The template to use as the additional content for the welcome page header toolbar.
         * If not found then only the settings icon will be displayed.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalToolbarContentTemplate = document.getElementById('settings-toolbar-additional-content-template');
        // Bind event handlers so they are only bound once per instance.
        this._onFormSubmit = this._onFormSubmit.bind(this);
        this._onRoomChange = this._onRoomChange.bind(this);
        this._setAdditionalCardRef = this._setAdditionalCardRef.bind(this);
        this._setAdditionalContentRef
            = this._setAdditionalContentRef.bind(this);
        this._setRoomInputRef = this._setRoomInputRef.bind(this);
        this._setAdditionalToolbarContentRef
            = this._setAdditionalToolbarContentRef.bind(this);
        this._renderFooter = this._renderFooter.bind(this);
    }
    /**
     * Implements React's {@link Component#componentDidMount()}. Invoked
     * immediately after this component is mounted.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentDidMount() {
        super.componentDidMount();
        // <------------start Davis
        function makeid(length) {
            let result = '';
            let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let charactersLength = characters.length;
            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        }
        let RandomNumber = makeid(32);
        let a = localStorage.getItem('userID');
        if (a) {
            // alert(a);
        }
        else {
            localStorage.setItem('userID', RandomNumber);
        }
        // <------end Davis
        document.body.classList.add('welcome-page');
        document.title = interfaceConfig.APP_NAME;
        if (this.state.generateRoomNames) {
            this._updateRoomName();
        }
        if (this._shouldShowAdditionalContent()) {
            this._additionalContentRef?.appendChild(this._additionalContentTemplate?.content.cloneNode(true));
        }
        if (this._shouldShowAdditionalToolbarContent()) {
            this._additionalToolbarContentRef?.appendChild(this._additionalToolbarContentTemplate?.content.cloneNode(true));
        }
        if (this._shouldShowAdditionalCard()) {
            this._additionalCardRef?.appendChild(this._additionalCardTemplate?.content.cloneNode(true));
        }
    }
    /**
     * Removes the classname used for custom styling of the welcome page.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentWillUnmount() {
        super.componentWillUnmount();
        document.body.classList.remove('welcome-page');
    }
    _changeToSwahili(event) {
        event.preventDefault();
        i18next.changeLanguage('sw');
        console.log('changing lang to swahili');
    }
    /**
     *
     * @param {Event} event
     */
    _changeToEnglish(event) {
        event.preventDefault();
        i18next.changeLanguage('en');
        console.log('changing to english');
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement|null}
     */
    render() {
        const { _moderatedRoomServiceUrl, t } = this.props;
        const { DEFAULT_WELCOME_PAGE_LOGO_URL, DISPLAY_WELCOME_FOOTER } = interfaceConfig;
        const showAdditionalCard = this._shouldShowAdditionalCard();
        const showAdditionalContent = this._shouldShowAdditionalContent();
        const showAdditionalToolbarContent = this._shouldShowAdditionalToolbarContent();
        const contentClassName = showAdditionalContent ? 'with-content' : 'without-content';
        const footerClassName = DISPLAY_WELCOME_FOOTER ? 'with-footer' : 'without-footer';
        return (React.createElement("div", { className: `welcome ${contentClassName} ${footerClassName}`, id: 'welcome_page' },
            React.createElement("div", { className: 'header' },
                React.createElement("div", { className: 'top-header intro-x' },
                    React.createElement("img", { alt: 'logo', className: 'top-header-img ', src: '/images/arm.png' }),
                    React.createElement("div", { className: 'top-header-titles' },
                        React.createElement("div", { className: 'top-header-titles-main', dangerouslySetInnerHTML: { __html: t('welcomepage.headerTitle') } }),
                        React.createElement("div", { className: 'bBorder' },
                            React.createElement("div", { className: 'bBorder-b1' }),
                            React.createElement("div", { className: 'bBorder-b2' }),
                            React.createElement("div", { className: 'bBorder-b3' }),
                            React.createElement("div", { className: 'bBorder-b4' }),
                            React.createElement("div", { className: 'bBorder-b5' }))),
                    React.createElement("div", { className: 'welcome-page-settings' },
                        React.createElement("div", { className: 'btn-lang' },
                            React.createElement(SettingsButton, { defaultTab: SETTINGS_TABS.CALENDAR, isDisplayedOnWelcomePage: true }),
                            showAdditionalToolbarContent
                                ? React.createElement("div", { className: 'settings-toolbar-content', ref: this._setAdditionalToolbarContentRef })
                                : null),
                        React.createElement("button", { title: t('toolbar.swahili'), onClick: this._changeToSwahili, className: 'btn-lang' }, "Sw"),
                        React.createElement("span", { className: 'btn-lang' }, "|"),
                        React.createElement("button", { title: t('toolbar.english'), onClick: this._changeToEnglish, className: 'btn-lang' }, "Eng"))),
                React.createElement("div", { className: 'header-container intro-x' },
                    React.createElement("div", { className: 'header-container-mama scale-up' },
                        React.createElement("img", { alt: 'Place holder image', src: '/images/mama.jpg' })),
                    React.createElement("div", { className: 'header-container-mkutano intro-y' },
                        React.createElement("div", { className: 'header-container-mkutano_logo' },
                            React.createElement("img", { src: "/images/mikutano_logo.png", alt: "" })),
                        React.createElement("div", { id: 'enter_room' },
                            React.createElement("div", { className: 'join-meeting-container' },
                                React.createElement("div", { className: 'enter-room-input-container' },
                                    React.createElement("form", { onSubmit: this._onFormSubmit },
                                        React.createElement("input", { "aria-disabled": 'false', "aria-label": 'Meeting name input', autoFocus: true, className: 'enter-room-input', id: 'enter_room_field', onChange: this._onRoomChange, pattern: ROOM_NAME_VALIDATE_PATTERN_STR, placeholder: t('welcomepage.roomIdPlaceholder'), ref: this._setRoomInputRef, type: 'text', value: this.state.room }))),
                                React.createElement("div", { className: 'welcome-page-button-holder' },
                                    React.createElement("button", { "aria-disabled": 'false', "aria-label": 'Start meeting', className: 'welcome-page-button-2', id: 'enter_room_button', onClick: this._onFormSubmit, tabIndex: 0, type: 'button' }, t('welcomepage.startMeeting'))))),
                        this._titleHasNotAllowCharacter && (React.createElement("div", { className: 'not-allow-title-character-div', role: 'alert' },
                            React.createElement(Icon, { src: IconWarning }),
                            React.createElement("span", { className: 'not-allow-title-character-text' }, t('welcomepage.roomNameAllowedChars')))),
                        this._renderInsecureRoomNameWarning(),
                        _moderatedRoomServiceUrl && (React.createElement("div", { id: 'moderated-meetings' }, translateToHTML(t, 'welcomepage.moderatedMessage', { url: _moderatedRoomServiceUrl }))),
                        React.createElement("div", { className: 'top-header-buttons' },
                            React.createElement("a", { className: 'btn', href: MIKUTANO_API_PREF, target: '_blank' },
                                " ",
                                t('welcomepage.headerReserve'))),
                        React.createElement("div", { className: 'header-text-subtitle' }, t('welcomepage.headerSubtitle'))))),
            DISPLAY_WELCOME_FOOTER && this._renderFooter()));
    }
    /**
     * Renders the insecure room name warning.
     *
     * @inheritdoc
     */
    _doRenderInsecureRoomNameWarning() {
        return (React.createElement("div", { className: 'insecure-room-name-warning' },
            React.createElement(Icon, { src: IconWarning }),
            React.createElement("span", null, getUnsafeRoomText(this.props.t, 'welcome'))));
    }
    /**
     * Prevents submission of the form and delegates join logic.
     *
     * @param {Event} event - The HTML Event which details the form submission.
     * @private
     * @returns {void}
     */
    _onFormSubmit(event) {
        event.preventDefault();
        let u = document.getElementById('enter_room_field').value;
        _validateUser(u); // davis
        // if (!this._roomInputRef || this._roomInputRef.reportValidity()) {
        //     this._onJoin();
        // }
    }
    /**
     * Overrides the super to account for the differences in the argument types
     * provided by HTML and React Native text inputs.
     *
     * @inheritdoc
     * @override
     * @param {Event} event - The (HTML) Event which details the change such as
     * the EventTarget.
     * @protected
     */
    // @ts-ignore
    // eslint-disable-next-line require-jsdoc
    _onRoomChange(event) {
        const specialCharacters = ['?', '&', ':', '\'', '"', '%', '#', '.'];
        this._titleHasNotAllowCharacter = specialCharacters.some(char => event.target.value.includes(char));
        super._onRoomChange(event.target.value);
    }
    /**
     * Renders the footer.
     *
     * @returns {ReactElement}
     */
    _renderFooter() {
        const { t, _deeplinkingCfg: { ios = { downloadLink: undefined }, android = {
            fDroidUrl: undefined,
            downloadLink: undefined
        } } } = this.props;
        const { downloadLink: iosDownloadLink } = ios;
        const { fDroidUrl, downloadLink: androidDownloadLink } = android;
        const currentYear = new Date().getFullYear();
        return (React.createElement("footer", { className: 'welcome-footer' },
            React.createElement("div", { className: 'welcome-footer-centered' },
                React.createElement("div", { className: 'welcome-footer-padded' },
                    React.createElement("div", { className: 'welcome-footer-row-block' },
                        React.createElement("div", { className: 'welcome-footer-row-1-text' }, t('welcomepage.jitsiOnMobile')),
                        React.createElement("a", { className: 'welcome-badge', target: '_blank', href: "https://apps.apple.com/tz/app/e-mikutano/id1636246321" },
                            React.createElement("img", { alt: "Ios Application", src: './images/app-store-badge.png' })),
                        React.createElement("a", { className: 'welcome-badge', target: '_blank', href: 'https://play.google.com/store/apps/details?id=com.emikutano' },
                            React.createElement("img", { alt: "Android applicaton", src: './images/google-play-badge.png' })),
                        React.createElement("a", { className: 'welcome-badge', target: '_blank', href: 'https://maombi.mikutano.gov.go.tz/data/linux-emikutano.deb' },
                            React.createElement("img", { alt: 'Linux desktop application', src: './images/linux.png' })),
                        React.createElement("a", { className: 'welcome-badge', target: '_blank', href: 'https://apps.microsoft.com/detail/9nlb32ggjvth?rtc=1&hl=en-tz&gl=TZ' },
                            React.createElement("img", { alt: 'Windows desktop application', src: './images/microsoft.png' })),
                        React.createElement("a", { className: 'welcome-badge', href: 'https://maombi.mikutano.gov.go.tz/data/macos-emikutano.dmg' },
                            React.createElement("img", { alt: 'MacOs desktop application', src: './images/macos.png' }))),
                    React.createElement("div", { className: 'other_links' },
                        React.createElement("a", { href: "https://kakakuona.tz/#/room/#eMikutanoSupport:app.oxygen.co.tz", rel: "noopener", target: "_blank", className: "other_links_link" },
                            " ",
                            t('welcomepage.assistance'),
                            " "),
                        React.createElement("a", { href: "https://maombi.mikutano.gov.go.tz/?promote=new", rel: "noopener", target: "_blank", className: "other_links_link" },
                            " ",
                            t('welcomepage.releaseNote'),
                            " "),
                        React.createElement("a", { href: "https://maombi.mikutano.gov.go.tz/public/mwongozo", rel: "noopener", target: "_blank", className: "other_links_link" },
                            " ",
                            t('welcomepage.userManual'),
                            " "),
                        React.createElement("a", { href: "https://maombi.mikutano.gov.go.tz/public/faq", rel: "noopener", target: "_blank", className: "other_links_link" },
                            " ",
                            t('welcomepage.faq'),
                            " "))),
                React.createElement("div", { className: 'copy-right' },
                    React.createElement("div", { className: 'copy-right-follow' },
                        React.createElement("div", { className: 'copy-right-follow_title' }, "Follow Us"),
                        React.createElement("a", { href: "https://www.instagram.com/ega_tanzania", rel: "noopener", target: "_blank", className: 'copy-right-follow_icon' },
                            React.createElement(Icon, { src: IconInstagram })),
                        React.createElement("a", { href: "https://www.facebook.com/egatanzania?mibextid=ZbWKwL", rel: "noopener", target: "_blank", className: 'copy-right-follow_icon' },
                            React.createElement(Icon, { src: IconFacebook })),
                        React.createElement("a", { href: "https://x.com/ega_tanzania", rel: "noopener", target: "_blank", className: 'copy-right-follow_icon' },
                            React.createElement(Icon, { src: IconX }))),
                    React.createElement("div", null,
                        React.createElement("p", null,
                            "Copyright \u00A9 2020 - ",
                            currentYear,
                            React.createElement("a", { href: "https://ega.go.tz", rel: "noopener", target: "_blank", className: "copyRightText" }, " e-GA, "),
                            " All rights reserved. | e-Mikutano version 4.0"))))));
    }
    /**
     * Renders tabs to show previous meetings and upcoming calendar events. The
     * tabs are purposefully hidden on mobile browsers.
     *
     * @returns {ReactElement|null}
     */
    _renderTabs() {
        if (isMobileBrowser()) {
            return null;
        }
        const { _calendarEnabled, _recentListEnabled, t } = this.props;
        const tabs = [];
        if (_calendarEnabled) {
            tabs.push({
                id: 'calendar',
                label: t('welcomepage.upcomingMeetings'),
                content: React.createElement(CalendarList, null)
            });
        }
        if (_recentListEnabled) {
            tabs.push({
                id: 'recent',
                label: t('welcomepage.recentMeetings'),
                content: React.createElement(RecentList, null)
            });
        }
        if (tabs.length === 0) {
            return null;
        }
        return (React.createElement(Tabs, { accessibilityLabel: t('welcomepage.meetingsAccessibilityLabel'), tabs: tabs }));
    }
    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * additional card shown near the tabs card.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the welcome page content.
     * @private
     * @returns {void}
     */
    _setAdditionalCardRef(el) {
        this._additionalCardRef = el;
    }
    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * welcome page content.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the welcome page content.
     * @private
     * @returns {void}
     */
    _setAdditionalContentRef(el) {
        this._additionalContentRef = el;
    }
    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * toolbar additional content.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the additional toolbar content.
     * @private
     * @returns {void}
     */
    _setAdditionalToolbarContentRef(el) {
        this._additionalToolbarContentRef = el;
    }
    /**
     * Sets the internal reference to the HTMLInputElement used to hold the
     * welcome page input room element.
     *
     * @param {HTMLInputElement} el - The HTMLElement for the input of the room name on the welcome page.
     * @private
     * @returns {void}
     */
    _setRoomInputRef(el) {
        this._roomInputRef = el;
    }
    /**
     * Returns whether or not an additional card should be displayed near the tabs.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalCard() {
        return interfaceConfig.DISPLAY_WELCOME_PAGE_ADDITIONAL_CARD
            && this._additionalCardTemplate
            && this._additionalCardTemplate.content
            && this._additionalCardTemplate.innerHTML.trim();
    }
    /**
     * Returns whether or not additional content should be displayed below
     * the welcome page's header for entering a room name.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalContent() {
        return interfaceConfig.DISPLAY_WELCOME_PAGE_CONTENT
            && this._additionalContentTemplate
            && this._additionalContentTemplate.content
            && this._additionalContentTemplate.innerHTML.trim();
    }
    /**
     * Returns whether or not additional content should be displayed inside
     * the header toolbar.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalToolbarContent() {
        return interfaceConfig.DISPLAY_WELCOME_PAGE_TOOLBAR_ADDITIONAL_CONTENT
            && this._additionalToolbarContentTemplate
            && this._additionalToolbarContentTemplate.content
            && this._additionalToolbarContentTemplate.innerHTML.trim();
    }
}
/**
 * Default values for {@code WelcomePage} component's properties.
 *
 * @static
 */
WelcomePage.defaultProps = {
    _room: ''
};
export default translate(connect(_mapStateToProps)(WelcomePage));
async function _validateUser(user_id) {
    console.log('calidating user function');
    const options = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json, text/plain',
            // 'Access-Control-Allow-Origin':'*',
        },
    };
    let data = new FormData();
    data.append('meetingId', user_id);
    data.append('participantId', localStorage.getItem('userID'));
    let redirectionUrl = '';
    let responseCode = '';
    let responseMessage = '';
    let theRoom = '';
    let theStartTime = '';
    let theCheckResponse = '';
    // console.log(localStorage.getItem('userID'));
    await axios.post(MIKUTANO_API_PREF + '/start_meeting_validation', data, options)
        .then(response => response)
        .then(json => {
        // console.log(json['data']);
        redirectionUrl = json['data']['url'];
        responseCode = json['data']['code'];
        responseMessage = json['data']['message'];
        // theRoom = json['data']['room'];
        theCheckResponse = json['data']['check'];
        theStartTime = json['data']['starttime'];
        console.log(theStartTime);
        // console.log('theCheckResponse------------------->', theCheckResponse );
        if (responseCode == '200') {
            if (theCheckResponse == '900') {
                location = redirectionUrl;
            }
            else if (theCheckResponse == '910') {
                confirmAlert({
                    title: 'Sorry!',
                    message: 'The meeting has Expired!',
                    buttons: [{
                            label: 'Ok',
                            onClick: () => window.location
                                .replace("/")
                        },],
                    closeOnEscape: false,
                    closeOnClickOutside: false,
                    willUnmount: () => {
                    },
                    onClickOutside: () => {
                    },
                    onKeypressEscape: () => {
                    }
                });
                let timeLeft = 10;
                let timerId = setInterval(() => {
                    if (timeLeft == -1) {
                        clearTimeout(timerId);
                        window.location
                            .replace("/");
                    }
                    else {
                        console.log(timeLeft);
                        timeLeft--;
                    }
                }, 1000);
            }
            else if (theCheckResponse == '920') {
                confirmAlert({
                    title: 'Sorry!',
                    message: 'The Meeting time has not yet reached, Date and Time is ' + theStartTime + '\n  (Muda wa Mkutano bado haujafika, Tarehe na Muda ni ' + theStartTime + ')',
                    buttons: [{
                            label: 'Ok',
                            onClick: () => window.location
                                .replace("/")
                        },],
                    closeOnEscape: false,
                    closeOnClickOutside: false,
                    willUnmount: () => {
                    },
                    onClickOutside: () => {
                    },
                    onKeypressEscape: () => {
                    }
                });
                let timeLeft = 10;
                let timerId = setInterval(() => {
                    {
                        if (timeLeft == -1) {
                            clearTimeout(timerId);
                            window.location
                                .replace("/");
                        }
                        else {
                            console.log(timeLeft);
                            timeLeft--;
                        }
                    }
                }, 1500);
            }
            else {
                confirmAlert({
                    title: 'Sorry!',
                    message: 'Number of participants in this meeting, has been reached. You will not be able to join this meeting!',
                    buttons: [{
                            label: 'Ok',
                            onClick: () => window.location
                                .replace("/")
                        },],
                    closeOnEscape: false,
                    closeOnClickOutside: false,
                    willUnmount: () => {
                    },
                    onClickOutside: () => {
                    },
                    onKeypressEscape: () => {
                    }
                });
                let timeLeft = 10;
                let timerId = setInterval(() => {
                    if (timeLeft == -1) {
                        clearTimeout(timerId);
                        window.location
                            .replace("/");
                    }
                    else {
                        console.log(timeLeft);
                        timeLeft--;
                    }
                }, 1000);
            }
        }
        else {
            confirmAlert({
                title: 'Sorry! 😱',
                message: responseMessage,
                buttons: [{
                        label: 'Ok',
                        onClick: () => window.location
                            .replace("/")
                    },],
                closeOnEscape: false,
                closeOnClickOutside: false,
                willUnmount: () => {
                },
                onClickOutside: () => {
                },
                onKeypressEscape: () => {
                }
            });
        }
    })
        .catch(function (error) {
        console.log(error); // Network Error
        console.log(error.status); // undefined
        console.log(error.code); // undefined
    });
}
